<template>
  <div
    v-if="feeds.length"
    class="FeedPins panel panel-default"
    role="navigation"
    :aria-label="$t('nav.pinned_feeds')"
  >
    <div class="panel-body feed-pins-row">
      <router-link
        v-for="item in feeds"
        :key="item.name"
        v-slot="{ href, navigate, isExactActive }"
        :to="item.to"
        custom
      >
        <a
          :href="href"
          class="button-unstyled feed-pin"
          :class="{ '-active': isCurrent(item, isExactActive) }"
          :aria-current="isCurrent(item, isExactActive) ? 'page' : undefined"
          :title="item.labelRaw || $t(item.label)"
          :aria-label="item.labelRaw || $t(item.label)"
          @click="navigate"
        >
          <FAIcon
            v-if="item.icon"
            fixed-width
            :icon="item.icon"
          />
          <img
            v-else-if="item.iconEmojiUrl"
            class="feed-pin-emoji"
            :src="item.iconEmojiUrl"
            alt=""
          >
          <span
            v-else
            class="feed-pin-letter"
          >{{ item.iconEmoji || item.iconLetter }}</span>
        </a>
      </router-link>
    </div>
  </div>
</template>

<script src="./feed_pins.js"></script>

<style lang="scss">
/* the pinned feeds under the post field: a cell each, the one on screen
   underlined (a div, not a nav: nav elements are styled as the top bar) */
.FeedPins {
  .feed-pins-row {
    display: flex;
    overflow: hidden;
    border-radius: var(--roundness);
  }

  .feed-pin {
    flex: 1 1 0;
    min-width: 0;
    display: grid;
    place-items: center;
    height: 2.9em;
    border-bottom: 3px solid transparent;

    --icon: var(--textFaint);

    color: var(--icon);

    &:hover,
    &:focus-visible {
      --icon: var(--text);

      background: color-mix(in oklab, var(--text) 6%, transparent);
    }

    &:focus-visible {
      outline: 2px solid color-mix(in oklab, var(--accent) 70%, transparent);
      outline-offset: -2px;
    }

    &.-active {
      --icon: var(--link);

      border-bottom-color: var(--link);
    }
  }

  .feed-pin-letter {
    font-weight: 700;
  }

  .feed-pin-emoji {
    width: 1.25em;
    height: 1.25em;
    object-fit: contain;
  }
}
</style>
